var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23C12.6193 23.0008 13.2235 22.8086 13.7285 22.4502C14.2335 22.0917 14.6143 21.5849 14.818 21H9.182C9.38566 21.5849 9.76648 22.0917 10.2715 22.4502C10.7765 22.8086 11.3807 23.0008 12 23V23ZM19 15.586V11C19 7.783 16.815 5.073 13.855 4.258C13.562 3.52 12.846 3 12 3C11.154 3 10.438 3.52 10.145 4.258C7.185 5.074 5 7.783 5 11V15.586L3.293 17.293C3.19996 17.3857 3.12617 17.4959 3.07589 17.6172C3.0256 17.7386 2.99981 17.8687 3 18V19C3 19.2652 3.10536 19.5196 3.29289 19.7071C3.48043 19.8946 3.73478 20 4 20H20C20.2652 20 20.5196 19.8946 20.7071 19.7071C20.8946 19.5196 21 19.2652 21 19V18C21.0002 17.8687 20.9744 17.7386 20.9241 17.6172C20.8738 17.4959 20.8 17.3857 20.707 17.293L19 15.586Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.b112fc914b6c9c22c1c3bace401175cd.svg";
export { ForwardRef as ReactComponent };